import { createAuth0Client } from '@auth0/auth0-spa-js';

class Auth0Client {
  #client
  constructor() {}

  async #init() {
    if (this.#client) return;
    this.#client = await createAuth0Client({
      domain: process.env.VUE_APP_AUTH_DOMAIN,
      clientId: process.env.VUE_APP_AUTH_CLIENT_ID,
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      authorizationParams: {
        prompt: "login",
        scope: process.env.VUE_APP_AUTH_SCOPE,
        audience: process.env.VUE_APP_AUTH_AUDIENCE,
        redirect_uri: window.location.origin,
      },
    });
  }
  async signIn() {
    await this.#init();
    await this.#client.loginWithRedirect({
      authorizationParams: {},
    });
  }
  async signUp() {
    await this.#init();
    await this.#client.loginWithRedirect({
      authorizationParams: { screen_hint: "signup" }
    });
  }
  async signInRedirectCallback(url) {
    return await this.#client.handleRedirectCallback(url);
  }
  async signOut() {
    try {
      await this.#init();
      await this.#client.logout({
        openUrl: (url) => {
          localStorage.clear();
          window.location.assign(
            url + "&returnTo=" + encodeURIComponent(window.location.origin)
          );
        },
      });

    } catch (e) {
      console.error(e.message)
    }
  }
  async isAuthenticated() {
    try {
      await this.#init();
      return await this.#client.isAuthenticated();
    } catch (e) {
      console.error(e.message)
      return false;
    }
  }
  async getAccessToken() {
    return await this.#client.getTokenSilently();
  }
  async getUser() {
    try {
      await this.#init();
      return await this.#client.getUser();
    } catch (e) {
      console.error(e.message)
      return null;
    }
  }
}

export default new Auth0Client()
